module.exports = __webpack_public_path__ + "img/kv.e2fa71a7.png";